import { AirlineLogo } from '@voll-intelligence/intelligence-ui-kit';
import { useGenUiConfig } from '../../../../shared/ui/config.js';
import { CheckoutLoyaltyLine } from '../checkout_loyalty.js';
import type { FlightCheckoutItem } from './checkout_legs.js';
import { flightLoyaltyPrograms } from './loyalty_match.js';

/**
 * A linha de fidelidade do card 1click do aéreo (#5340): uma entrada por
 * programa das companhias dos trechos — «LATAM Pass •••• 1234 · Programa de
 * milhas aplicado» quando o perfil o tem, «Adicionar programa de fidelidade»
 * quando não. Só com o port e com o viajante igual a quem está logado (o perfil
 * lido é o dele; num colega a linha não existe).
 */
export function FlightCheckoutLoyalty({
  items,
  self,
  record,
}: {
  readonly items: readonly FlightCheckoutItem[];
  /** O único viajante é quem está logado. */
  readonly self: boolean;
  readonly record: boolean;
}) {
  const port = useGenUiConfig().loyalty;
  if (!port || !self) return null;
  return (
    <CheckoutLoyaltyLine
      programs={flightLoyaltyPrograms(items)}
      usePlans={port.useAirPlans}
      record={record}
      appliedKey="productCheckout.loyalty.applied"
      onAdd={port.openAdd}
      renderMark={(program) => (
        <span className="flex size-7 shrink-0 items-center justify-center rounded-md bg-sand-3">
          <AirlineLogo iata={program.codes[0] ?? ''} name={program.owner} size={20} />
        </span>
      )}
    />
  );
}
